var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAltRoute = function SvgAltRoute(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    fill: "currentColor"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "alt_route_svg__a",
    width: 25,
    height: 25,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.024.545h24v24h-24z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#alt_route_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.024 22.545v-5q0-1.4-.425-2.075a6.7 6.7 0 0 0-1.125-1.325L10.9 12.72q.3.276.575.588.276.313.55.662a7 7 0 0 1 .713-.837q.363-.363.737-.713a11.4 11.4 0 0 0 1.725-2.025q.776-1.15.825-4.025L14.45 7.945l-1.425-1.4 4-4 4 4-1.4 1.4-1.6-1.575q-.05 3.576-1.1 5.088t-2.1 2.462a9.4 9.4 0 0 0-1.3 1.413q-.5.687-.5 2.212v5zM6.224 8.72a8 8 0 0 1-.137-1.1q-.038-.6-.063-1.25l-1.6 1.575-1.4-1.4 4-4 4 4-1.425 1.4-1.575-1.55q0 .526.05.988.05.463.1.862zm2.15 4.4a9 9 0 0 1-.962-1.225q-.463-.699-.813-1.725l1.925-.475q.25.675.575 1.15t.7.85z"
  }))));
};
export default SvgAltRoute;